document.addEventListener('DOMContentLoaded', function() {
  const sections = document.querySelectorAll('.the-darl-logo-list');
  
  sections.forEach(section => {
    const sectionId = section.getAttribute('data-section-id');
    const slides = section.querySelectorAll('.logo-list__item');
    let currentSlide = 0;
    const totalSlides = slides.length;

    // Function to go to the next slide
    function nextSlide() {
      slides[currentSlide].classList.remove('active');
      
      currentSlide = (currentSlide + 1) % totalSlides; // Loop back to the first slide
      
      slides[currentSlide].classList.add('active');
    }

    // Initialize the first slide as active
    if (slides.length > 0) {
      slides[0].classList.add('active');
    }

    // Set the interval for automatic sliding
    setInterval(nextSlide, 3000); // seconds per slide
  });
});